import * as olSource from "ol/source"

const OSM_URL =
	process.env.REACT_APP_MAP_TILE_URL ||
	"https://tile.openstreetmap.org/{z}/{x}/{y}.png"

function OsmCache() {
	return new olSource.OSM({
		url: OSM_URL,
		attributions: [
			"&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors" +
			" &middot; <a href=\"https://www.openstreetmap.org/fixthemap\">Report a map issue</a>"
		],
		maxZoom: 19,
		crossOrigin: "anonymous"
	})
}

export {
	OsmCache
}
